module.exports = __webpack_public_path__ + "static/media/single.73076eaf.txt";